<template>
  <div>
    <form @submit.prevent="submitCustomer">
      <v-row>
        <v-col
          cols="12"
          md="8"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>General</div>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.firstName"
                    hide-details="auto"
                    label="First Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('firstName')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.lastName"
                    hide-details="auto"
                    label="Last Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('lastName')"
                  />
                </v-col>
                <!--  -->
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="customer.email"
                    hide-details="auto"
                    label="Email"
                    outlined
                    dense
                    :error-messages="errors.getMessage('email')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="customer.phone"
                    hide-details="auto"
                    label="Phone"
                    outlined
                    dense
                    :error-messages="errors.getMessage('phone')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="customer.address"
                    label="Address"
                    outlined
                    rows="2"
                    dense
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            class="mt-3"
          >
            <v-card-text>
              <div>More</div>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="customer.identification"
                    hide-details="auto"
                    label="Identification"
                    outlined
                    dense
                    :error-messages="errors.getMessage('identification')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="customer.taxId"
                    hide-details="auto"
                    label="TaxId"
                    outlined
                    dense
                    :error-messages="errors.getMessage('taxId')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <v-card
            outlined
            class="mt-4"
          >
            <v-card-text>
              <div>Properties</div>
              <v-col
                cols="12"
                md="12"
              >
                <v-select
                  v-model="customer.gender"
                  :items="['Male', 'Female']"
                  outlined
                  label="Gender"
                  dense
                  :error-messages="errors.getMessage('gender')"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="customer.dateOfBirth"
                  hide-details="auto"
                  label="Date Of Birth"
                  type="date"
                  outlined
                  dense
                  :error-messages="errors.getMessage('dateOfBirth')"
                />
              </v-col>
            </v-card-text>
          </v-card>
          <div class="text-center">
            <v-btn
              color="green"
              class="ma-2 white--text"
              type="submit"
            >
              Save
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              :to="{ name: 'CustomersList' }"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      edit: false,
      customer: {},
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      this.getFromApi();
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    updateCustomer() {
      let data = this.$data.customer;
      window.axios.patch("/customer/" + data.id, data).then((response) => {
        this.feedback(response.data.message);
        this.$router.replace({ name: "CustomersList" });
      });
    },
    createCustomer() {
      window.axios.post("/customer", this.$data.customer).then((response) => {
        this.feedback(response.data.message);
        if (this.$route.name !== "PosSale") {
          this.$router.replace({ name: "PosSale" });
        }
      });
    },
    submitCustomer() {
      if (this.$data.edit) {
        this.updateCustomer();
      } else {
        this.createCustomer();
      }
    },
    getFromApi() {
      window.axios
        .get("/customer/" + this.$route.params.id)
        .then((response) => {
          this.$data.customer = response.data.customer;
          this.$data.edit = true;
        });
    },
  },
};
</script>
